import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

const initialState = {
  caricamentoInCorso: false,
  schedeTecniche: [],
  caricamentoDettagli: false,
  dettagliScheda: [],
  mostraDettagli: false,
  currentScheda: null,
  currentCliente: false,
  clienti: [],
};

const schedeSlice = createSlice({
  name: 'schede',
  initialState,
  reducers: {
    caricamento(state, action) {
      state.caricamentoInCorso = Boolean(action.payload);
    },
    aggiornaSchede(state, action) {
      state.schedeTecniche = action.payload;
    },
    aggiornaDettagliScheda(state, action) {
      state.dettagliScheda = action.payload;
    },

    caricamentoDettagli(state, action) {
      state.caricamentoDettagli = action.payload;
    },
    mostraDettagli(state, action) {
      state.currentScheda = action.payload;
      state.mostraDettagli = true;
    },
    nascondiDettagli(state) {
      state.mostraDettagli = false;
    },
    aggiornaClienti(state, action) {
      const [primo] = action.payload;
      state.clienti = _.uniq(action.payload);
      state.currentCliente = primo;
    },
    aggiornaCurrentCliente(state, action) {
      state.currentCliente = action.payload;
    },
  },
});

export const {
  caricamento,
  aggiornaSchede,
  aggiornaDettagliScheda,
  caricamentoDettagli,
  mostraDettagli,
  nascondiDettagli,
  aggiornaClienti,
  aggiornaCurrentCliente,
} = schedeSlice.actions;
const schedeReducer = schedeSlice.reducer;

export default schedeReducer;
